import React, { createContext, useContext, useReducer } from "react";
export const DataLayerContext = createContext();

//children significa todo lo que en index.js este dentro del DataLayer
export const DataLayer = ({ initialState, reducer, children }) => (
  <DataLayerContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </DataLayerContext.Provider>
);

export const useDataLayerValue = () => useContext(DataLayerContext);
